import { Icon, Stack, TooltipHost } from "@fluentui/react";
import React, { useContext,useState } from "react";
import ReportCount from "../../../components/SVGComponents/ReportCount";
import ImageCount from "../../../components/SVGComponents/ImageCount";
import RowBadge from "./Badge/RowBadge";
import ChatIcon from "../../../components/SVGComponents/ChatIcon";
import studylistContext from "../../../context/studylist/StudylistContext";
import Moment from "moment";
import { toolTipStyles } from "../../StudyViewer/styles/styles";
import { CUSTOM_STYLES, USERTYPES, modalityRowBadgeColor } from "../../../constants/Constants";
import UploadedHistoryIcon from "../../../components/SVGComponents/StudyList/Actions/UploadedHistoryIcon";
import UploadHistoryIcon from "../../../components/SVGComponents/StudyList/Actions/UploadHistoryIcon";
import userContext from "../../../context/users/UserContext";
import UploadHistory from "./UploadHistory/UploadHistory";
import { FilePDBIcon } from "@fluentui/react-icons-mdl2";
import studyReportContext from "../../../context/studyreport/StudyReportContext";
import { t } from "i18next";
import CustomToolTipHost from "../../../components/CustomToolTipHost/CustomToolTipHost";
import themeContext from "../../../context/theme/ThemeContext";



const mainStackStylesForFirmTech = {
  // lineHeight: "20px",
  // height: "121px",
  // width: "210px",
  justifyContent: "center",
  marginTop: process.env.REACT_APP_HYBRID_MODE == "true" ?"8px":"14px",
  marginBottom: process.env.REACT_APP_HYBRID_MODE == "true" ?"unset":"10px",
  // transform: "translateY(-39%)"
};

const hospitalStackStyles = {
  fontSize: "14px",
  fontWeight: "400",
  alignItems: "center"
};

const modalityStyle = {
  marginLeft: "10px",
  backgroundColor: "#BBDEFF",
  height: "14px",
  fontSize: "9px",
  color: "#0035BE",
  display: "flex",
  alignItems: "center",
  width: "fit-content",
  fontWeight: "bolder",
  padding: "0px 5px",
  borderRadius: "5px",
};

const studyUploadDateStyle = {
  fontSize: "11px",
  fontWeight: "400",
};

const studyDetailsStackStyle = {
  alignItems: "center",
  marginBottom: process.env.REACT_APP_HYBRID_MODE == "true" ?"4px":"unset",
  // marginTop: "2px",
  // marginBottom: "7px",
};

const studyDetailsIconTextStyle = {
  fontSize: "14px",
  fontWeight: "400",
  paddingLeft: "15px",
  display:'flex',
  alignItems:'center',
  marginLeft:'7px'
};

const studyDetailsIconTextStyleReport = {
  fontSize: "14px",
  fontWeight: "400",
  display:'flex',
  alignItems:'center',
};

const studyDetailsIconsContainer = {
  display: "flex",
  justifyContent: "space-between",
  flex: "1",
  position: "relative",
  cursor: "pointer",
  // width: "64%",
  height: "24px !important",
  marginTop: "5px",
  marginBottom: "5px",
};


const msgIconToolTipStyles = {
  root: {
    height: "24px",
    display: "flex",
    alignItems: "center",
  },
};

const StudyDetails = (props) => {

  const {roles , isActiveData} = useContext(userContext);
  const {
    returnedReasonCount,
    setShowCommunicationModal,
    showReturnedStudyReasonModal,
    setShowReturnedStudyReasonModal,
    showChats,
    showUploadHistoryModalGloState, setShowUploadHistoryModalGloState,
    studyListSearchDateFilterValue, showReferringPhysician,
  } = useContext(studylistContext);

  const { getAlterColor ,theme} = useContext(themeContext);

  const mainStackStyles = {
    justifyContent: "center",
    marginTop: CUSTOM_STYLES.STUDYLIST_TD_TOP_MARGIN,
  };

  const { getConsistentDateFormat } = useContext(studyReportContext);

  const [showUploadHistoryModal, setShowUploadHistoryModal] = useState(false);



  const customDescriptionStyles = {
    root: "studylist-study-description"
  }

  const customToolTipStyleForIcons = {
    root: "study-list-report-image-count-container",
  }


  return (
    <>
    {showUploadHistoryModal &&
        <UploadHistory 
        setShowUploadHistoryModal={setShowUploadHistoryModal} 
        showUploadHistoryModal={showUploadHistoryModal} 
        studyId={props.data.row.original.id} 
        isChild={props.data.row.depth !== 0}
        activeData = {props.data.row.original.fromActiveData}
        clientId={props.data.row.original.assignmentList[0]?.clientId} 
        firmId = {props.data.row.original.assignmentList[0]?.firmId}
        modalityId = {props.data.row.original.modalityId}
        />
      }
   <div
    style={{
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: 'center'
    }}
    
    >
      <Stack data-tut={"tour-study-details"} style={(roles[0] == USERTYPES.FIRMDOCTOR || roles[0] == USERTYPES.FIRMTECHNICIAN) ? mainStackStylesForFirmTech: mainStackStyles}>
            
              <CustomToolTipHost
                content={props.data.row.original.studyDescription}
                styles={customDescriptionStyles}
                id={"tooltip_"}
                >
                {props.data.row.original.studyDescription == ""
                  ? t("label.no-description")
                  : props.data.row.original.studyDescription}
              </CustomToolTipHost>

              {roles[0] !== USERTYPES.ADMIN && (showReferringPhysician || process.env.REACT_APP_VDC_PLATFORM === "true") && 
                <span className="study-list-study-date">
                  <TooltipHost content={"Referring Physician"}>
                  {t("sorting.study-list.ref-physician")}:&nbsp;&nbsp;
                  </TooltipHost>
                  <CustomToolTipHost
                  content={props.data.row.original.referringPhysician} styles={customDescriptionStyles} id={"tooltip_"}>
                  <span className="study-list-date">{props.data.row.original.referringPhysician || "-"}</span>
                  </CustomToolTipHost>
                </span>
              }
          {/* <span className="study-list-study-date">
            {t("sorting.study-list.study-date")}:&nbsp;&nbsp;
            {getConsistentDateFormat(props.data.row.original.studyDateDisplay)}
          </span> */}

          {(roles[0] == USERTYPES.RADIOLOGIST && process.env.REACT_APP_VDC_PLATFORM === "true" && studyListSearchDateFilterValue == 2) ? 
            <span className="study-list-study-date report-date">
              <CustomToolTipHost
              content={`${getConsistentDateFormat(props.data.row.original.assignmentList[0].reportSubmittedDateDisplay)}`} id={"tooltip_"}>
              {t("sorting.study-list.report-date")}:&nbsp;&nbsp;
                {getConsistentDateFormat(props.data.row.original.assignmentList[0].reportSubmittedDateDisplay)}
              </CustomToolTipHost>
            </span> : 
            <span className="study-list-study-date">
              <CustomToolTipHost
              content={`${getConsistentDateFormat(props.data.row.original.studyDateDisplay)}`} id={"tooltip_"}>
              {t("sorting.study-list.study-date")}:&nbsp;&nbsp;
              <span className="study-list-date">{getConsistentDateFormat(props.data.row.original.studyDateDisplay)}</span>
              </CustomToolTipHost>
            </span>
          }

        <div
          style={studyDetailsIconsContainer}
        >
          {((roles[0] == USERTYPES.TYPIST && showChats)||(roles[0] != USERTYPES.TYPIST)) && (props.data.row.original.userSpecificMessageCount > 0) && (
            <div
                className={`study-list-user-message-pop-up ${props.data.row.original.newMessageFlag ? "fa-blink" : ""}`}
              style={{
                background: props.data.row.original.newMessageFlag
                  ? "red"
                  : getAlterColor("#F7F7F7", "rgb(173 173 173)"),
              }}
            >
              <span className="study-list-message-count-popup">
                {props.data.row.original.userSpecificMessageCount}
              </span>
            </div>
          )}
         { ((roles[0] == USERTYPES.TYPIST && showChats)||(roles[0] != USERTYPES.TYPIST)) && (<CustomToolTipHost
            content={t("label.chat")}
            id={"tooltip_"}
            styles={msgIconToolTipStyles}
          >
            <div
             style={{display:'flex',alignItems:'center'}}
            onClick={() =>{
              setShowCommunicationModal({
                studyId: props.data.row.original.id,
                show: true,
                child:props.data.row.depth !== 0
              })
            }}
            >
            <ChatIcon
              color={theme.palette.inactiveTool}
              active={
                props.data.row.original.userSpecificMessageCount > 0
                  ? true
                  : false
              }
            />
            
            </div>
            
          </CustomToolTipHost>
          )} 
          <span style={{ ...studyDetailsIconTextStyle }}>
            <CustomToolTipHost
              content={`${t("label.total-images")} : ${props.data.row.original.noOfImages}`}
              styles={customToolTipStyleForIcons}
              id={"tooltip_"}
            >
              <ImageCount />{" "}
              <span className="study-list-study-imagecount studylist-number-of-images">
                {props.data.row.original.noOfImages < 10 ? "0" : ""}
                {props.data.row.original.noOfImages}
              </span>
            </CustomToolTipHost>
          </span>
          {/* <span style={{ ...studyDetailsIconTextStyleReport }}>
            <CustomToolTipHost
              content={`${t("label.total-reports")} : ${props.data.row.original.noOfReports}`}
              styles={customToolTipStyleForIcons}
              id={"tooltip_"}
            >
              <ReportCount />{" "}
              <span className="study-list-study-imagecount">
                {props.data.row.original.noOfReports < 10 ? "0" : ""}
                {props.data.row.original.noOfReports}
              </span>
            </CustomToolTipHost>
          </span> */}
          <HistoryAttachment data={props.data} setShowUploadHistoryModal={setShowUploadHistoryModal} />
          <div style={{display:'flex',alignItems:'center',marginLeft:'7px'}}>
          <RowBadge
          customClassName = "study-list-modality-badge"
          tooltipText={`Modality: ${props.data.row.original.modality.name}`}
            name={props.data.row.original.modality.name}
            colorObj={modalityRowBadgeColor(
              props.data.row.original.modality.name
            )}
          />
          </div>
          
          
        </div>
      </Stack>

     
        </div>
    </>
  );
};

export default StudyDetails;


export const HistoryAttachment = (props) => {

  const { showHistory } = useContext(studylistContext);

  const {roles,contextSwitchUser, isActiveData } = useContext(userContext);
  const { getThemeColor, themeName} = useContext(themeContext);
  const checkForAnyUploadedHistory = () => {
    //if((props.data.row.original?.historyPresent == null || props.data.row.original?.historyPresent == false) && props.data.row.original?.studyHistoryDocList?.length == 0){
    if(props.data.row.original?.historyStatus!=null && props.data.row.original?.historyStatus){   
       return true;
    }
    return false;
  }

  const checkForViewHistory = () => {
    if(((roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.FIRMADMIN || roles[0] == USERTYPES.FIRMDOCTOR || roles[0] == USERTYPES.SUPERVISOR || roles[0] == USERTYPES.FIRMTECHNICIAN) && (props.data.row.depth !== 0))){
      return true;
    }else{
      return false;
    }
  }

  const customToolTipStyleForIcons = {
    root: "study-list-report-image-count-container",
  }

  return (<>
   <div style={{marginLeft:'10px',display:'flex'
      // padding:roles[0] === USERTYPES.RADIOLOGIST ? "5px 10px":"5px 8px",
      // marginBottom:roles[0] === USERTYPES.FIRMTECHNICIAN ? "5px":props.data.row.depth != 0 ? "10px":"unset"
      
      }}  className={``}>
          {!contextSwitchUser && (roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.FIRMADMIN || roles[0] == USERTYPES.FIRMDOCTOR || roles[0] == USERTYPES.SUPERVISOR || roles[0] == USERTYPES.FIRMTECHNICIAN) && (props.data.row.depth === 0) &&
          <CustomToolTipHost
          content={t("upload-history.title")}
              styles={customToolTipStyleForIcons}
              id={"Upload_History"}
          >
           <div
            onClick={() => {
              props.setShowUploadHistoryModal(true)
            }}
            className="study-list-report-icon"
          >
            
           
                <UploadHistoryIcon active = {checkForAnyUploadedHistory()}/>
            
            
          </div>
          </CustomToolTipHost>
          }

    {(roles[0] == USERTYPES.RADIOLOGIST || checkForViewHistory() || (roles[0] == USERTYPES.TYPIST && showHistory)) &&
          <CustomToolTipHost
          content={t("upload-history.view-history")}
              styles={customToolTipStyleForIcons}
              id={"view_history"}
          >
           <div
            onClick={() => {
              props.setShowUploadHistoryModal(true)
            }}
            className="study-list-report-icon"
          >
           <Icon
           style={{color:checkForAnyUploadedHistory()?'rgb(20 123 255)':themeName != "light"?'#C1C1C1':getThemeColor("study-details-icon")}}
           iconName={"FilePDB"}></Icon>
          </div>
          </CustomToolTipHost>
          }
        </div>
  </>)
}
